module.exports = __webpack_public_path__ + "v294910/img/icon.b52a0829.png";